// src/app/auth.service.ts
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Amplify } from 'aws-amplify';
import { environment } from '../environments/environment';
import {
  signIn,
  confirmSignIn,
  signOut,
  getCurrentUser,
  fetchAuthSession,
  SignInOutput,
} from 'aws-amplify/auth';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private cachedUsername = '';
  private cachedPassword = '';
  private idToken: string | null = null;

  constructor(private router: Router) {
    console.log(environment)
    const config = environment.cognitoConfigs[environment.region];
    console.log(config)
    Amplify.configure(config as any);
  }

  async login(
    username: string,
    password: string
  ): Promise<true | 'NEW_PASSWORD_REQUIRED' | false> {
    try {
      try {
        const user = await getCurrentUser();
        if (user) await signOut();
      } catch { }

      const response: SignInOutput = await signIn({ username, password });

      if (response.nextStep?.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
        this.cachedUsername = username;
        this.cachedPassword = password;
        return 'NEW_PASSWORD_REQUIRED';
      }

      if (response.isSignedIn) {
        const session = await fetchAuthSession();
        this.idToken = session.tokens?.idToken?.toString() || null;
        this.router.navigate(['/home']);
        return true;
      }

      return false;
    } catch (error) {
      console.error('Login error:', error);
      return false;
    }
  }

  async getUserGroups(): Promise<string[]> {
    const session = await fetchAuthSession();
    const idToken = session.tokens?.idToken;

    if (!idToken) return [];

    const payload = idToken.payload as any;
    return payload['cognito:groups'] || [];
  }

  async hasGroup(group: string): Promise<boolean> {
  const groups = await this.getUserGroups();
  return groups.includes(group);
}

  async completePasswordChange(newPassword: string): Promise<boolean> {
    try {
      const response: SignInOutput = await signIn({
        username: this.cachedUsername,
        password: this.cachedPassword,
      });

      if (response.nextStep?.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
        const result = await confirmSignIn({
          challengeResponse: newPassword,
        });

        if (result.isSignedIn) {
          const session = await fetchAuthSession();
          this.idToken = session.tokens?.idToken?.toString() || null;
          this.router.navigate(['/home']);
          return true;
        }
      }

      return false;
    } catch (error) {
      console.error('Password change error:', error);
      return false;
    }
  }

  async getToken(): Promise<string | null> {
    if (!this.idToken) {
      const session = await fetchAuthSession();
      this.idToken = session.tokens?.idToken?.toString() || null;
    }
    return this.idToken;
  }

  async logout(): Promise<void> {
    this.idToken = null;
    await signOut();
    this.router.navigate(['/login']);
  }

  async isLoggedIn(): Promise<boolean> {
    try {
      const user = await getCurrentUser();
      return !!user;
    } catch {
      return false;
    }
  }
}
